module.exports = __webpack_public_path__ + "img/mini_arrow_shack_disable.8580e9b6.svg";